import React from 'react';
import ErrorBoundary from './errorBoundary';
import { useNavigate } from 'react-router-dom';

const ErrorBoundaryWithNavigate = (props) => {
  const navigate = useNavigate();
  return <ErrorBoundary {...props} navigate={navigate} />;
};

export default ErrorBoundaryWithNavigate;
